import * as React from "react";
import {useEffect, useContext} from "react";
import {Profile} from "../queries/Profile";
import {SurroundingContext} from "../state/associationContext";
import {GodFatherContext} from "../state/associationContext";
import useToken from "../../../components/useToken";
import {useUserInfo} from "../../userInfo/hooks/useUserInfo";
import {RoleContext} from "../../userInfo/context/roleContext";

export const useSurroundings = () => {
    const {state, dispatch} = useContext(SurroundingContext);
    const {dispatchFather} = useContext(GodFatherContext);
    const {stateRole, dispatchRole} = useContext(RoleContext);
    const { switchToken, revertToken } = useToken();
    const {reload, setToSwitchMode} = useUserInfo();

    useEffect(()=> {
        state.length === 0 &&
        Profile.getSurroundings().then((response) => dispatch({type: "initAssociationSurroundingList",payload:response}))
    },[])

    const linkAccount = async (mail,type) => {
        return await Profile.linkAccount(mail,type).then((res) => {
            if (res.status === 200) {
                return true;
            }
            if (res.status !== 200) {
                throw new Error(res.data.message);
            }


        })

    }

    const unlinkAccount = (mail) => {
        Profile.unlinkAccount(mail).then((status) => {
            if (status === 204) {
                dispatch({type: "removeSurrounding",payload:mail})
                dispatchFather({type: "removeGodFather",payload:mail})
            }
        })
    }

    const switchAccount = (mail) => {
        Profile.switchAccount(mail).then((response) => {
            console.log(response);
            dispatchRole({type: "initRole",payload:response.JWT.role});
            switchToken(response.JWT._token);
            setToSwitchMode(true);
            window.location.reload();
        })
    }



    return {surroundings:state, linkAccount, unlinkAccount, switchAccount}

}
